import { render, staticRenderFns } from "./SPRSimpleCheckbox.vue?vue&type=template&id=3ee11938&scoped=true"
import script from "./SPRSimpleCheckbox.vue?vue&type=script&lang=js"
export * from "./SPRSimpleCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SPRSimpleCheckbox.vue?vue&type=style&index=0&id=3ee11938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee11938",
  null
  
)

export default component.exports